import { h, Fragment } from "preact";
import ProductOptionSwatch from "./product-option-swatch";
import ProductOptionInlineHeader from "./product-option-inline-header";

export default function ProductOptionSwatchesInline({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  variantsByOptionValue = [],
  unavailableOptionValues = [],
  waitlistOptionValues = [],
  last,
  disabledSwatchStyle,
  optionSize,
}) {
  return (
    <div
      className={`
        product-options__option-inline
        ${last ? "product-options__option-inline--last" : ""}
        product-options__swatches-inline
        `}
    >
      <ProductOptionInlineHeader
        optionName={optionName}
        selectedOptionValue={selectedOptionValue}
      />

      <fieldset
        className={`product-options__swatch-list-inline product-options__swatch-list-inline--${optionSize}`}
      >
        <legend className="visually-hidden">{optionName}</legend>
        {optionValues.map((optionValue) => (
          <ProductOptionSwatch
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            optionVariant={variantsByOptionValue.find(
              (variantByOptionValue) =>
                variantByOptionValue.optionValue === optionValue.name,
            )}
            unavailable={unavailableOptionValues.includes(optionValue.name)}
            waitlist={waitlistOptionValues.includes(optionValue.name)}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
            disabledSwatchStyle={disabledSwatchStyle}
            optionSize={optionSize}
          />
        ))}
      </fieldset>
    </div>
  );
}
